import { Check } from "lucide-react";

export default function ChoiceQuestion({ q, value, onChange }) {
  const multi = q.type === "multi";
  const sel = multi ? value || [] : value;

  const toggle = (v) => {
    if (!multi) return onChange(v);
    if (sel.includes(v)) return onChange(sel.filter((x) => x !== v));
    if (v === q.exclusive) return onChange([v]);
    const base = sel.filter((x) => x !== q.exclusive);
    if (q.max && base.length >= q.max) return;
    onChange([...base, v]);
  };

  const limitReached = multi && q.max && sel.filter((x) => x !== q.exclusive).length >= q.max;

  return (
    <div className="space-y-3" data-testid={`question-${q.id}-options`}>
      {multi && (
        <p className="text-sm text-stone-500" data-testid="multi-hint">
          {q.max ? `Escolha até ${q.max} opções.` : "Escolha todas as opções que se aplicam."}
        </p>
      )}
      {q.options.map((o) => {
        const on = multi ? sel.includes(o.value) : sel === o.value;
        return (
          <button
            key={o.value}
            type="button"
            className="choice flex items-center justify-between gap-3"
            data-selected={on}
            disabled={multi && !on && limitReached && o.value !== q.exclusive}
            onClick={() => toggle(o.value)}
            data-testid={`option-${q.id}-${o.value}`}
          >
            <span>{o.text}</span>
            <span className={`flex h-6 w-6 shrink-0 items-center justify-center border ${multi ? "rounded-md" : "rounded-full"} ${on ? "border-stone-900 bg-stone-900 text-white" : "border-stone-300"}`}>
              {on && <Check size={14} />}
            </span>
          </button>
        );
      })}
    </div>
  );
}
